import { EMPLOYEES_API } from '@/utils/apis'

// 開啟後台 2.0 的指定頁面。
// 先在使用者點擊當下開空白分頁，再等 token 回來設定網址，避免非同步後才 window.open 被瀏覽器擋下。
// 分頁開不成（被擋或非點擊觸發）時不導向，回傳網址讓呼叫端改用連結或同分頁開啟。
export async function openAdmin2(axios, page) {
  const win = window.open('', '_blank')

  try {
    const res = await axios.post(`${EMPLOYEES_API}/token`)
    const { host, id, token } = res.data.data
    const url = `${host}/fantasy?id=${id}&token=${token}&page=${page}`

    if (!win) {
      return url
    }

    win.opener = null
    win.location.href = url

    return null
  } catch (e) {
    if (win) {
      win.close()
    }

    throw e
  }
}
